// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page__t6PoI {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 70px 1fr;
  row-gap: 12px;
  height: 100dvh;
  max-height: 100dvh;
  flex-direction: column;
  box-sizing: border-box;
  overflow-y: hidden;
}

.body__nrU4O {
  display: grid;
  grid-template-columns: minmax(350px, 1fr) minmax(500px, 700px);
  flex-grow: 1;
  box-sizing: border-box;
  min-height: 0;
  height: 100%;
  max-height: 100%;
}

.designView__O9YvL {
  box-sizing: border-box;
  background-color: white;
  margin: 16px 16px 4px 16px;
  border-radius: 5px;
  border: 1px solid var(--border-grey);
}

.toastMessage__QKXX5 {
  position: fixed;
  top: 104px;
  left: 49%;
  transform: translate(-50%, -50%);
  z-index: 1;
}

.designSummaryComponent__So7Mp {
  box-sizing: border-box;
  margin: 10px 6px 16px 16px;
  display: grid;
  grid-template-columns: 1fr;
  padding-right: 4px;
  grid-template-rows: 50px 1fr 80px;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
}

.summaryComponentContainer__Zoj8f {
  overflow-y: auto;
  padding-right: 6px;
}

.summaryButtons__iNV6L {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  padding: 0 12px 0 0;
}

.summaryButtonsLeft__jGNfi {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 24px;
}

.topBar__TJypp {
  display: grid;
  grid-template-columns: 100px 1fr 163px;
  align-items: center;
  padding: 0 12px;
}

.title__fn8kp {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 12px 0;
}

.toggle__SYG9M {
  border-radius: 40px;
  position: relative;
  width: 216px;
  height: 35px;
  padding: 0 12px;
  border: 1px solid var(--border-grey);
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.toggleHandle__Aov9I {
  position: absolute;
  left: 3px; /* Start at the beginning of the toggle */
  top: 3px;
  width: 120px;
  height: 29px;
  background-color: var(--border-blue);
  z-index: -1;
  border-radius: 40px;
  transition: transform 0.3s ease, width 0.3s ease; /* Animate the transform property */
}

.toggleHandle__Aov9I.internalView__ScpSB {
  transform: translateX(
    129px
  ); /* Move right by the difference between the toggle width and handle width */
  width: 105px;
}

@media (max-width: 800px) {
  .body__nrU4O {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
  }
  .design-summary-component__yLWe0 {
    margin-top: 8px;
  }
  .design-view__gFOsn {
    margin-bottom: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/containers/design-view-app/style.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,0BAA0B;EAC1B,4BAA4B;EAC5B,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,UAAU;EACV,SAAS;EACT,gCAAgC;EAChC,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,iCAAiC;EACjC,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,oCAAoC;EACpC,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,yCAAyC;EACpD,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,WAAW;EACX,mBAAmB;EACnB,gDAAgD,EAAE,mCAAmC;AACvF;;AAEA;EACE;;GAEC,EAAE,2EAA2E;EAC9E,YAAY;AACd;;AAEA;EACE;IACE,0BAA0B;IAC1B,2BAA2B;EAC7B;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".page {\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: 70px 1fr;\n  row-gap: 12px;\n  height: 100dvh;\n  max-height: 100dvh;\n  flex-direction: column;\n  box-sizing: border-box;\n  overflow-y: hidden;\n}\n\n.body {\n  display: grid;\n  grid-template-columns: minmax(350px, 1fr) minmax(500px, 700px);\n  flex-grow: 1;\n  box-sizing: border-box;\n  min-height: 0;\n  height: 100%;\n  max-height: 100%;\n}\n\n.designView {\n  box-sizing: border-box;\n  background-color: white;\n  margin: 16px 16px 4px 16px;\n  border-radius: 5px;\n  border: 1px solid var(--border-grey);\n}\n\n.toastMessage {\n  position: fixed;\n  top: 104px;\n  left: 49%;\n  transform: translate(-50%, -50%);\n  z-index: 1;\n}\n\n.designSummaryComponent {\n  box-sizing: border-box;\n  margin: 10px 6px 16px 16px;\n  display: grid;\n  grid-template-columns: 1fr;\n  padding-right: 4px;\n  grid-template-rows: 50px 1fr 80px;\n  height: 100%;\n  max-height: 100%;\n  overflow: hidden;\n}\n\n.summaryComponentContainer {\n  overflow-y: auto;\n  padding-right: 6px;\n}\n\n.summaryButtons {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 24px;\n  padding: 0 12px 0 0;\n}\n\n.summaryButtonsLeft {\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  gap: 24px;\n}\n\n.topBar {\n  display: grid;\n  grid-template-columns: 100px 1fr 163px;\n  align-items: center;\n  padding: 0 12px;\n}\n\n.title {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 12px 0;\n}\n\n.toggle {\n  border-radius: 40px;\n  position: relative;\n  width: 216px;\n  height: 35px;\n  padding: 0 12px;\n  border: 1px solid var(--border-grey);\n  display: flex;\n  justify-content: space-between;\n  cursor: pointer;\n}\n\n.toggleHandle {\n  position: absolute;\n  left: 3px; /* Start at the beginning of the toggle */\n  top: 3px;\n  width: 120px;\n  height: 29px;\n  background-color: var(--border-blue);\n  z-index: -1;\n  border-radius: 40px;\n  transition: transform 0.3s ease, width 0.3s ease; /* Animate the transform property */\n}\n\n.toggleHandle.internalView {\n  transform: translateX(\n    129px\n  ); /* Move right by the difference between the toggle width and handle width */\n  width: 105px;\n}\n\n@media (max-width: 800px) {\n  .body {\n    grid-template-columns: 1fr;\n    grid-template-rows: 1fr 1fr;\n  }\n  .design-summary-component {\n    margin-top: 8px;\n  }\n  .design-view {\n    margin-bottom: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `page__t6PoI`,
	"body": `body__nrU4O`,
	"designView": `designView__O9YvL`,
	"toastMessage": `toastMessage__QKXX5`,
	"designSummaryComponent": `designSummaryComponent__So7Mp`,
	"summaryComponentContainer": `summaryComponentContainer__Zoj8f`,
	"summaryButtons": `summaryButtons__iNV6L`,
	"summaryButtonsLeft": `summaryButtonsLeft__jGNfi`,
	"topBar": `topBar__TJypp`,
	"title": `title__fn8kp`,
	"toggle": `toggle__SYG9M`,
	"toggleHandle": `toggleHandle__Aov9I`,
	"internalView": `internalView__ScpSB`,
	"design-summary-component": `design-summary-component__yLWe0`,
	"design-view": `design-view__gFOsn`
};
export default ___CSS_LOADER_EXPORT___;
